import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule} from '@angular/flex-layout';
import {TranslateModule} from '@ngx-translate/core';
import {MatInputModule} from "@angular/material/input";


@Component({
  selector: 'app-confirm',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    FlexLayoutModule,
    TranslateModule
  ],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss',
})
export class ConfirmDialogComponent {
  message: string;
  paramValue: string

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      message: string;
      param: string
    },
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    dialogRef.disableClose = true;
    this.message = data.message;
    this.paramValue = data.param;
  }
}
